/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef, useContext } from "react";
import {
  InputBase,
  FormLabel,
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio,
  Button,
  Box,
} from "@mui/material/";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid2";
import SearchIcon from "@mui/icons-material/Search";
import Select from "react-select";
import {
  useStyles,
  searchSicha,
  getAbstractsBySubject,
  getSubjects,
  filterSubjects,
  createQuery,
  parseQueries,
  customStyles,
  PARSHIOT,
  ORDERED_MONTHES,
} from "./SearchInputService";
import "./searchInput.css";
import { englishContext } from "../../../contexts";

// import { create } from "jss";
// import rtl from "jss-rtl";
// import { StylesProvider, jssPreset, createTheme, ThemeProvider } from '@mui/material/styles';

// const jss = create({ plugins: [...jssPreset().plugins, rtl()] });

// const rtlTheme = createTheme({ direction: "rtl" });
// const ltrTheme = createTheme({ direction: "ltr" });

export default function SearchInput(props) {
  const classes = useStyles();
  const navigate = useNavigate();
  const searchTimeout = useRef(null);
  const [field, setField] = useState("abstractText");
  const [value, setValue] = useState("");
  const [page, setPage] = useState(props.page);
  const [subjectsLists, setSubjectsLists] = useState("");
  const [rambamLables, setRambamLables] = useState("");
  const [monthDayWeekDayOriginal, setMonthDayWeekDayOriginal] = useState("");
  const [selectedSubjects, setSelectedSubjects] = useState({
    subjects: "",
    rambamLesson: "",
    rambamHalacha: "",
    weekDay: "",
    parshaNum: "",
    monthNum: "",
    monthDay: "",
    deliveredYear: "",
    deliveredDate: "",
    idID: "",
  });
  const { isEnglish } = useContext(englishContext);

  const {
    subjects,
    rambamHalacha,
    weekDay,
    parshaNum,
    monthNum,
    monthDay,
    deliveredDate,
    deliveredYear,
    idID,
  } = selectedSubjects;

  useEffect(() => {
    const searchData = JSON.parse(sessionStorage.getItem("search"));
    if (searchData) {
      setSelectedSubjects(() => searchData.selectedSubjects);
      setValue(() => searchData.value);
      setField(() => searchData.field);
      setPage(() => searchData.page);
    } else if (window.location.search) {
      const { page, field, value, selected } = parseQueries();
      setSelectedSubjects({ ...selectedSubjects, ...selected });
      setValue(value);
      setField(field);
      props.setPage(page);
      setPage(page);
      search(page);
    }
    getSubjects().then((res) => {
      setSubjectsLists(res);
      setMonthDayWeekDayOriginal({
        monthDay: res.monthDay,
        weekDay: res.weekDay,
        deliveredDate: res.deliveredDate,
      });
    });
  }, []);

  useEffect(() => {
    searchTimeout.current = setTimeout(() => {
      const query = createQuery(field, value, selectedSubjects, page - 1);
      navigate("?" + query);
      if (
        value ||
        (!Object.values(selectedSubjects).every((s) => s.value === "ללא") &&
          !Object.values(selectedSubjects).every((s) => !!s.value === false))
      ) {
        const query = createQuery(field, value, selectedSubjects, page - 1);
        setTimeout(() => {
          navigate("?" + query);
        });
        search(1);
      } else {
        const query = createQuery(field, value, selectedSubjects, page - 1);
        navigate("?" + query);
        props.getSichos([]);
        props.getCount(0);
        sessionStorage.removeItem("search");
      }
    }, 700);
    return () => {
      clearTimeout(searchTimeout);
    };
  }, [
    field,
    value,
    subjects,
    rambamHalacha,
    weekDay,
    parshaNum,
    monthNum,
    monthDay,
    deliveredDate,
    deliveredYear,
    idID,
  ]);

  useEffect(() => {
    if (
      value ||
      subjects.value ||
      rambamHalacha.value ||
      weekDay.value ||
      parshaNum.value ||
      monthNum.value ||
      monthDay.value ||
      deliveredYear.value ||
      deliveredDate.value
    ) {
      setPage(props.page);
    }
  }, [props.page]);

  useEffect(() => {
    if (
      value ||
      subjects.value ||
      rambamHalacha.value ||
      weekDay.value ||
      parshaNum ||
      parshaNum.value ||
      monthNum.value ||
      monthDay.value ||
      deliveredYear.value ||
      deliveredDate.value
    ) {
      const query = createQuery(field, value, selectedSubjects, page - 1);
      navigate("?" + query);
      search(page);
    }
  }, [page]);

  useEffect(() => {
    let rambam = subjectsLists.rambamHalacha?.map((less, i) => {
      return less === "ללא"
        ? "ללא"
        : `שיעור ${subjectsLists.rambamLesson[i]} - ${less}`;
    });

    rambam = [...new Set(rambam)];
    setRambamLables(rambam);
    setSubjectsLists((state) => {
      return { ...state, rambamHalacha: [...new Set(state.rambamHalacha)] };
    });
  }, [subjectsLists.rambamLesson]);


  useEffect(() => {
    if (props.injected && props.injected.term != null) {
      setField("abstractText");
      setSelectedSubjects({
        subjects: "",
        rambamLesson: "",
        rambamHalacha: "",
        weekDay: "",
        parshaNum: "",
        monthNum: "",
        monthDay: "",
        deliveredYear: "",
        deliveredDate: "",
        idID: "",
      });
      setValue(props.injected.term);
    }
    // eslint-disable-next-line
  }, [props.injected]);

  const handleSearchChange = (e) => {
    if (props.onExitKeywordMode) props.onExitKeywordMode();
    setValue(() => e.target.value);
  };

  const handleFieldChange = (e) => {
    setField(e.target.value);
  };

  const clearSearchTimeout = () => {
    window.clearTimeout(searchTimeout.current);
  };

  const handleChange = (value, e) => {
    const name = e.name;
    const selected = value.value;
    setSelectedSubjects({ ...selectedSubjects, [name]: value });
    if (name === "monthNum" && selected !== "") {
      filterSubjects("monthNum", "monthDay", selected).then((res) => {
        setSubjectsLists({ ...subjectsLists, monthDay: res });
      });
    } else if (name === "parshaNum" && selected !== "") {
      filterSubjects("parshaNum", "weekDay", selected).then((res) => {
        setSubjectsLists({ ...subjectsLists, weekDay: res });
      });
    } else if (name === "deliveredYear" && selected !== "") {
      filterSubjects("deliveredYear", "deliveredDate", selected).then((res) => {
        setSubjectsLists({ ...subjectsLists, deliveredDate: res });
      });
    } else if (name === "monthNum") {
      setSubjectsLists({
        ...subjectsLists,
        monthDay: monthDayWeekDayOriginal.monthDay,
      });
    } else if (name === "parshaNum") {
      setSubjectsLists({
        ...subjectsLists,
        weekDay: monthDayWeekDayOriginal.weekDay,
      });
    } else if (name === "deliveredYear") {
      setSubjectsLists({
        ...subjectsLists,
        deliveredDate: monthDayWeekDayOriginal.deliveredDate,
      });
    }
  };

  const createList = (data, listName) => {
    // const l = data?.length;
    return data?.map((item, i) => {
      let label;
      switch (listName) {
        case "rambamHalacha":
          label = rambamLables[i];
          break;
        case "parshaNum":
          label = PARSHIOT[item - 1] || "ללא";
          break;
        case "monthNum":
          label = ORDERED_MONTHES[item - 1] || "ללא";
          break;
        default:
          label = item;
          break;
      }
      return {
        value: item === "ללא" ? "" : item,
        label: label,
        // label: typeof item === 'number' && l > 50 ? PARSHIOT[item - 1] : typeof item === 'number' && l < 20 ? ORDERED_MONTHES[item - 1] : rambam ? rambamLables[i] : item,
      };
    });
  };

  const clearFields = () => {
    setValue("");
    setSelectedSubjects({
      subjects: "",
      rambamHalacha: "",
      weekDay: "",
      parshaNum: "",
      monthNum: "",
      monthDay: "",
      deliveredYear: "",
      deliveredDate: "",
      idID: "",
    });
    sessionStorage.removeItem("search");
  };

  const search = (pageNum) => {
    if (
      value ||
      (!Object.values(selectedSubjects).every((s) => s.value === "ללא") &&
        !Object.values(selectedSubjects).every((s) => !!s.value === false))
    ) {
      props.setPage(pageNum);
      searchSicha(window.location.search).then(({ sichos, count }) => {
        props.getValue(value);
        props.getSichos(sichos);
        props.getCount(count);
        const searchData = { field, value, selectedSubjects, page: props.page };
        sessionStorage.setItem("search", JSON.stringify(searchData));
      });
    }
  };

  const getAbstracts = () => {
    if (
      value ||
      (!Object.values(selectedSubjects).every((s) => s.value === "ללא") &&
        !Object.values(selectedSubjects).every((s) => !!s.value === false))
    ) {
      getAbstractsBySubject(window.location.search).then((res) => {
        props.getAbstracts(res);
      });
    }
  };

  return (
    <div className={classes.root + (props.keywordMode ? " kw-mode" : "")}>
      
      <Grid container spacing={1} className="advanced">
        <Grid size={{ xs: 12 }}>
          <Button
            fullWidth
            color="primary"
            variant="contained"
            onClick={() =>
              props.keywordMode
                ? props.onExitKeywordMode && props.onExitKeywordMode()
                : props.onKeywordMode && props.onKeywordMode()
            }
            sx={{ mb: 1.5, fontWeight: 700 }}
          >
            {props.keywordMode
              ? isEnglish
                ? "Close Index"
                : "סגירת המפתח"
              : isEnglish
              ? "Index"
              : "מפתח ענינים"}
          </Button>
        </Grid>
        <Grid size={{ xs: 12 }} m="6px">
          <FormControl component="fieldset" className={classes.formControl}>
            <Box className={classes.searchWrapper} display="flex">
              <div className={classes.search}>
                <InputBase
                  placeholder={isEnglish ? "Search Text" : "חיפוש טקסט..."}
                  className="search-input"
                  onChange={handleSearchChange}
                  value={value}
                  inputProps={{ "aria-label": "search" }}
                />
              </div>
              <Button
                className="search-btn"
                color="primary"
                variant="contained"
                onClick={() => search(1)}
              >
                <SearchIcon />
              </Button>
            </Box>

            <RadioGroup
              className="field-group"
              name="field"
              onChange={handleFieldChange}
              value={field}
            >
              <FormLabel className="s-label" component="legend">
                {isEnglish ? "Search in:" : "חפש ב:"}
              </FormLabel>
              <FormControlLabel
                value="abstractText"
                control={<Radio color="primary" />}
                label={isEnglish ? "Synopsis" : "תוכן השיחות"}
              />
              <FormControlLabel
                value="contentText"
                control={<Radio color="primary" />}
                label={isEnglish ? "Hanochos in Yiddish" : "הנחות באידיש"}
              />
              <FormControlLabel
                value="contentHebText"
                control={<Radio color="primary" />}
                label={isEnglish ? "Translation to Hebtrew" : 'תרגום ללה"ק'}
              />
              <FormControlLabel
                value="contentEngText"
                control={<Radio color="primary" />}
                label={isEnglish ? "Translation to English" : "תרגום לאנגלית"}
              />
            </RadioGroup>
          </FormControl>
        </Grid>
        <Grid size={{ xs: 12 }}>
          <div className="filter-header">
            {isEnglish ? "Advanced Search" : "חיפוש מתקדם"}
          </div>
        </Grid>
        <Grid size={{ xs: 12 }}>
          <div className="filter-sub-head">
            {isEnglish ? "By Connection to Parsha:" : "לפי הקשר לפרשה:"}
          </div>
        </Grid>
        <Grid size={{ xs: 6 }}>
          <FormControl
            variant="outlined"
            className={classes.formControl + " select"}
          >
            <Select
              placeholder={isEnglish ? "Parsha" : "פרשה"}
              name="parshaNum"
              value={parshaNum}
              onChange={handleChange}
              onFocus={clearSearchTimeout}
              styles={customStyles}
              options={createList(subjectsLists.parshaNum, "parshaNum")}
            />
          </FormControl>
        </Grid>
        <Grid size={{ xs: 6 }}>
          <FormControl
            variant="outlined"
            className={classes.formControl + " select"}
          >
            <Select
              placeholder={isEnglish ? "Day in Week" : "יום בשבוע"}
              name="weekDay"
              value={weekDay}
              onChange={handleChange}
              onFocus={clearSearchTimeout}
              styles={customStyles}
              options={createList(subjectsLists.weekDay)}
            />
          </FormControl>
        </Grid>
        <Grid size={{ xs: 12 }}>
          <div className="filter-sub-head">
            {isEnglish ? "By Connection to date:" : "לפי הקשר לתאריך:"}
          </div>
        </Grid>
        <Grid size={{ xs: 6 }}>
          <FormControl
            variant="outlined"
            className={classes.formControl + " select"}
          >
            <Select
              placeholder={isEnglish ? "Month" : "חודש"}
              name="monthNum"
              value={monthNum}
              onChange={handleChange}
              onFocus={clearSearchTimeout}
              styles={customStyles}
              options={createList(subjectsLists.monthNum, "monthNum")}
            />
          </FormControl>
        </Grid>
        <Grid size={{ xs: 6 }}>
          <FormControl
            variant="outlined"
            className={classes.formControl + " select"}
          >
            <Select
              placeholder={isEnglish ? "Day of the month" : "יום בחודש"}
              name="monthDay"
              value={monthDay}
              onChange={handleChange}
              onFocus={clearSearchTimeout}
              styles={customStyles}
              options={createList(subjectsLists.monthDay)}
            />
          </FormControl>
        </Grid>
        <Grid size={{ xs: 12 }}>
          <div className="filter-sub-head">
            {isEnglish
              ? "By Connection to Shiur Rambam:"
              : 'לפי הקשר לשיעור הרמב"ם:'}
          </div>
        </Grid>
        <Grid size={{ xs: 12 }}>
          <FormControl
            variant="outlined"
            className={classes.formControl + " select"}
          >
            <Select
              placeholder={isEnglish ? "Shiur Rambam" : 'שיעור רמב"ם'}
              name="rambamHalacha"
              value={rambamHalacha}
              onChange={handleChange}
              onFocus={clearSearchTimeout}
              styles={customStyles}
              options={createList(subjectsLists.rambamHalacha, "rambamHalacha")}
            />
          </FormControl>
        </Grid>
        <Grid size={{ xs: 12 }}>
          <div className="filter-sub-head">
            {isEnglish ? "By Subject:" : "לפי נושא:"}
          </div>
        </Grid>
        <Grid size={{ xs: 12 }}>
          <FormControl
            variant="outlined"
            className={classes.formControl + " select"}
          >
            <Select
              placeholder={isEnglish ? "Subject" : "נושא"}
              name="subjects"
              value={subjects}
              onChange={handleChange}
              onFocus={clearSearchTimeout}
              styles={customStyles}
              options={createList(subjectsLists.subjects)}
            />
          </FormControl>
        </Grid>
        <Grid size={{ xs: 12 }}>
          <div className="filter-sub-head">
            {isEnglish ? "By the date of the Sicha:" : "לפי תאריך אמירת השיחה:"}
          </div>
        </Grid>
        <Grid size={{ xs: 6 }}>
          <FormControl
            variant="outlined"
            className={classes.formControl + " select"}
          >
            <Select
              placeholder={isEnglish ? "Year" : "שנה"}
              name="deliveredYear"
              value={deliveredYear}
              onChange={handleChange}
              onFocus={clearSearchTimeout}
              styles={customStyles}
              options={createList(subjectsLists.deliveredYear)}
            />
          </FormControl>
        </Grid>
        <Grid size={{ xs: 6 }}>
          <FormControl
            variant="outlined"
            className={classes.formControl + " select"}
          >
            <Select
              placeholder={isEnglish ? "Date" : "תאריך"}
              name="deliveredDate"
              value={deliveredDate}
              onChange={handleChange}
              onFocus={clearSearchTimeout}
              styles={customStyles}
              options={createList(subjectsLists.deliveredDate)}
            />
          </FormControl>
        </Grid>

        <Grid size={{ xs: 12 }}>
          <Box margin={2} display="flex" justifyContent="space-between">
            <Button color="primary" variant="outlined" onClick={clearFields}>
              {isEnglish ? "Clear Fields" : "נקה שדות"}
            </Button>
            <Button
              color="primary"
              variant="contained"
              onClick={() => search(1)}
            >
              {isEnglish ? "Search" : "חפש"}
            </Button>
          </Box>
        </Grid>
        <Grid size={{ xs: 12 }}>
          <div className="filter-sub-head">
            {isEnglish ? "By Sicha ID:" : "לפי מזהה שיחה (ID):"}
          </div>
        </Grid>
        <Grid size={{ xs: 12 }}>
          <FormControl
            variant="outlined"
            className={classes.formControl + " select"}
          >
            <Select
              placeholder={isEnglish ? "Sicha ID" : "מזהה שיחה (ID)"}
              name="idID"
              value={idID}
              onChange={handleChange}
              onFocus={clearSearchTimeout}
              styles={customStyles}
              options={createList(subjectsLists.ids)}
            />
          </FormControl>
        </Grid>
      </Grid>
      {props.auth && (
        <Grid size={{ xs: 12 }}>
          <Box margin={2}>
            <Button
              fullWidth
              color="primary"
              variant="outlined"
              onClick={getAbstracts}
            >
              {isEnglish
                ? "Show conversation content for printing"
                : "הצג תוכן שיחות להדפסה"}
            </Button>
          </Box>
        </Grid>
      )}
      {/* </ThemeProvider>
      </StylesProvider> */}
    </div>
  );
}
